import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const ReportsMain = lazy(() => import('../reports/ReportsMain'));
const ReportsWidget = lazy(() => import('../reports/ReportsWidget'));

export default [
  {
    id: NavConfig.groupConfigs.REPORTS_DASHBOARD.id,
    path: NavConfig.groupConfigs.REPORTS_DASHBOARD.to,
    element: (
      <ReportsMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </ReportsMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.REPORTS.to} />,
      },
      {
        id: NavConfig.linkConfigs.REPORTS.id,
        path: NavConfig.linkConfigs.REPORTS.to,
        element: <ReportsWidget />,
      },
    ],
  },
];
